import React from 'react';
import { formatDateForDisplay } from 'services/MomentUtils';
import { Badge } from 'react-bootstrap';
import { NOTIFY } from 'lookup/SwimConstants';


export default function CustomerAndClientTitle({
  globalSwitchId = "",
  customerName = "",
  clientName = "",
  customerDisplayId = "",
  clientDisplayId = "",
  creationDate = "",
  targetSwitchDate = "",
  shouldDisplayGlobalSwitchId = true,
  shouldDisplayDates = true,
  nameClassName = "",
  dateClassName = "",
  callActivityBlockStatus = null,
  includeNotifyBadge = false,
  isHsc = false

}) {
  console.log("isHsc value in CustomerAndClientTitle: ", isHsc);
  let name = clientName ?
    !customerName || clientName == customerName ? clientName :
      clientName + " (" + customerName + ")"
    : customerName ? "(" + customerName + ")" : "Client/Customer Name N/A";
  let displayIds = clientDisplayId ?
    !customerDisplayId ?
      " (Client# : " + clientDisplayId + ")"
      : " (Client# : " + clientDisplayId + " , Customer# : " + customerDisplayId + ")"
    : customerDisplayId ? " (Customer# : " + customerDisplayId + ")"
      : null;

  const statusConfig = {
    BLOCKED: { text: "Activities Blocked", bg: "danger" },
    OVERRIDDEN: { text: "Block Removed", bg: "success" },
  };

  const config = statusConfig[callActivityBlockStatus];

  return (
    <div>
      {shouldDisplayGlobalSwitchId ?
        <div>
          <div style={{ textAlign: 'center', fontSize: '0.8em' }}>
            <span className='text-muted'>Timezone:</span>&nbsp;
            <span >{Intl.DateTimeFormat().resolvedOptions().timeZone}</span>
          </div>
          <div className="text-center even-bigger-text">
            <span style={{verticalAlign: 'middle'}}>
              {globalSwitchId}
              {/* Notify Badge */}
              {includeNotifyBadge && <div>
                <Badge bg="danger" className="px-2 py-1" style={{ fontSize: '12px', textTransform: 'uppercase' }}>{NOTIFY}</Badge>
              </div>
              }
              {/* <FDTickets /> */}
              {config && (
                <Badge className="ms-2 align-middle fs-6" bg={config.bg}>
                  {config.text}
                </Badge>
              )}
            </span>
             {
                isHsc && <div>
                <Badge pill bg="warning hsc-badge">HSC</Badge>
                </div>
              }
          </div>
          <hr />
        </div>
        :
        null
      }
      <div className={nameClassName ? nameClassName : "bigger-text"} data-testid="text-customer-client">
        {name}
        {displayIds ?
          <span className={"text-muted normal-text"}>
            {displayIds}
          </span>
          : null}
      </div>
      {
        shouldDisplayDates ?
          <div className={dateClassName ? dateClassName : "text-muted"}>
            Created on
            <strong className="spacey">
              {creationDate ? ' ' + formatDateForDisplay(creationDate) + ' ' : ' N/A '}
            </strong>
            and effective from
            <strong className="spacey">
              {targetSwitchDate ? ' ' + formatDateForDisplay(targetSwitchDate) + ' ' : ' N/A '}
            </strong>
          </div>
          : null
      }
    </div>
  )
}
